<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="m4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "ArrowUpRight",
};
</script>
